import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Seo, breadcrumbJsonLd } from "../components/Seo";
import { Stagger, Item } from "../components/shared";
import { useI18n } from "../i18n/LanguageContext";

export default function BlogPage() {
  const { t, c } = useI18n();
  const b = t.blog;
  const [feature, ...rest] = c.BLOG;
  return (
    <div data-testid="blog-page">
      <Seo path="/blog" title={t.seo.blog.title} description={t.seo.blog.desc} image={c.BLOG[0].image}
        jsonLd={breadcrumbJsonLd([{ name: t.crumbHome, path: "/" }, { name: b.crumb, path: "/blog" }])} />
      <PageHero eyebrow={b.eyebrow} crumb={b.crumb} title={b.title} sub={b.sub} image={c.BLOG[0].image} />

      <section className="py-16 sm:py-24">
        <div className="container-x">
          <Link to={`/blog/${feature.slug}`} data-testid={`blog-card-${feature.slug}`}
            className="group grid overflow-hidden rounded-[2rem] bg-white shadow-soft transition-[transform,box-shadow] duration-500 hover:shadow-card lg:grid-cols-2">
            <div className="relative aspect-[16/10] overflow-hidden lg:aspect-auto">
              <img src={feature.image} alt={feature.title} className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105" />
            </div>
            <div className="flex flex-col justify-center p-8 sm:p-12">
              <div className="flex items-center gap-3">
                <span className="rounded-full bg-gold/10 px-3 py-1 text-xs font-medium text-gold">{feature.category}</span>
                <span className="flex items-center gap-1 text-xs text-muted"><Clock size={13} /> {feature.read}</span>
              </div>
              <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-navy sm:text-4xl">{feature.title}</h2>
              <p className="mt-4 text-base leading-relaxed text-muted">{feature.excerpt}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-gold">{b.read} <ArrowUpRight size={16} /></span>
            </div>
          </Link>

          <Stagger className="mt-8 grid gap-6 sm:grid-cols-2">
            {rest.map((post) => (
              <Item key={post.slug}>
                <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-soft transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-card">
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img src={post.image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105" />
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="flex items-center gap-3">
                      <span className="rounded-full bg-gold/10 px-3 py-1 text-xs font-medium text-gold">{post.category}</span>
                      <span className="flex items-center gap-1 text-xs text-muted"><Clock size={13} /> {post.read}</span>
                    </div>
                    <h3 className="mt-4 font-display text-xl font-semibold leading-snug tracking-tight text-navy">{post.title}</h3>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-muted">{post.excerpt}</p>
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-gold">{b.read} <ArrowUpRight size={15} /></span>
                  </div>
                </Link>
              </Item>
            ))}
          </Stagger>
        </div>
      </section>
    </div>
  );
}
